module.exports = __webpack_public_path__ + "static/media/16-5.18b2a46c.mp3";